import React from 'react';
import NavBar from '../components/NavBar';
import GameCard from '../components/GameCard';
import './Games.css';
import { Helmet } from 'react-helmet-async';

function WordGames() {
  const games = [
    {
      id: 'medievalwordtwister',
      title: 'Medieval Word Twister',
      description: 'Twist and turn letters to form words in a medieval setting. How many words can you find?',
      imageUrl: '/medievalwordtwister/assets/logo.png',
      link: '/play/medievalwordtwister',
      infoLink: '/games/medieval-word-twister'
    },
    {
      id: 'finalphrase',
      title: 'Final Phrase',
      description: 'Guess the hidden phrase one letter at a time. A classic word puzzle challenge!',
      imageUrl: '/finalphrase/assets/logo.png',
      link: '/play/finalphrase',
      infoLink: '/games/final-phrase'
    },
    {
      id: 'wordwheel',
      title: 'Word Wheel',
      description: 'Find as many words as you can in 60 seconds! Swipe across letters on the wheel to build words from 9 letters.',
      imageUrl: '/assets/logos/wordwheel_logo.svg',
      link: '/play/wordwheel',
      infoLink: '/games/word-wheel'
    },
    {
      id: 'wordladder',
      title: 'Word Ladder',
      description: 'Climb the puzzle one letter at a time! Change one letter per step to transform the starting word into the target word.',
      imageUrl: '/wordladder/icons/Icon-512.png',
      link: '/play/wordladder',
      infoLink: '/games/word-ladder'
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Word Puzzle Games - Medieval Word Twister & Final Phrase</title>
        <meta name="description" content="Challenge your vocabulary with our word puzzle games! Play Medieval Word Twister and Final Phrase - engaging word games that test your linguistic skills and expand your vocabulary." />
        <link rel="canonical" href="https://logicpuzzles.ca/word-games" />
        <meta property="og:title" content="Word Puzzle Games - Medieval Word Twister & Final Phrase" />
        <meta property="og:description" content="Challenge your vocabulary with our word puzzle games! Engaging word games that test your linguistic skills." />
        <meta property="og:url" content="https://logicpuzzles.ca/word-games" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://logicpuzzles.ca/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Word Puzzle Games - Medieval Word Twister & Final Phrase" />
        <meta name="twitter:description" content="Challenge your vocabulary with our word puzzle games! Engaging word games that test your linguistic skills." />
        <meta name="twitter:image" content="https://logicpuzzles.ca/og-image.png" />
      </Helmet>
      <NavBar />
      <div className="games-page">
        <div className="container">
          <p className="eyebrow">Word games</p>
          <h1>Our Word Games</h1>
          <p className="games-intro">
            Explore our collection of fun and challenging word games. Perfect for word enthusiasts of all levels!
          </p>
          {games.length > 0 ? (
            <div className="games-grid">
              {games.map((game, i) => (
                <GameCard
                  key={game.id}
                  title={game.title}
                  description={game.description}
                  imageUrl={game.imageUrl}
                  link={game.link}
                  infoLink={game.infoLink}
                  loading={i < 6 ? 'eager' : 'lazy'}
                />
              ))}
            </div>
          ) : (
            <p>No word games available at the moment. Please check back soon!</p>
          )}
          <section className="games-details">
            <h2>Build Vocabulary Through Play</h2>
            <p>
              Our word games focus on pattern recognition, spelling, and quick reasoning. Whether you're untangling letters
              or guessing a phrase, every puzzle rewards observation and a growing vocabulary.
            </p>
            <div className="games-details-grid">
              <div>
                <h3>Warm-Up Friendly</h3>
                <p>Short rounds make these games ideal for quick mental refreshers.</p>
              </div>
              <div>
                <h3>Strategy Over Speed</h3>
                <p>You can take your time and work through clues without pressure.</p>
              </div>
              <div>
                <h3>Daily Practice</h3>
                <p>Consistent play helps improve recall, spelling, and word fluency.</p>
              </div>
            </div>
          </section>
          <section className="games-faq">
            <h2>Word Games FAQ</h2>
            <div className="games-faq-grid">
              <div>
                <h3>Are these games good for kids?</h3>
                <p>Yes. The rules are simple and the puzzles help with vocabulary and spelling practice.</p>
              </div>
              <div>
                <h3>Do I need to play quickly?</h3>
                <p>No. You can solve at your own pace and come back anytime.</p>
              </div>
              <div>
                <h3>Do you add new word challenges?</h3>
                <p>Yes. We regularly add puzzles and refinements to keep the experience fresh.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default WordGames;
